import { useTypedSelector } from "store"
import { selectedColorSelector } from "../color/colorSelectors"
import { selectedDetailingSelector } from "../detailing/detailingSelectors"
import { selectedUpholsterySelector } from "../upholstery/upholsterySelectors"

const useInStock = () => {
  const modelHasStock = useTypedSelector((state) => state.wizard.model?.stock)
  const selectedColor = useTypedSelector(selectedColorSelector)
  const selectedUpholstery = useTypedSelector(selectedUpholsterySelector)
  const selectedDetailing = useTypedSelector(selectedDetailingSelector)

  const selectionsInStock =
    (!selectedColor?.details || selectedColor?.details?.inStock) &&
    (!selectedUpholstery?.details || selectedUpholstery?.details?.inStock) &&
    (!selectedDetailing?.details || selectedDetailing?.details?.inStock)

  if (!modelHasStock) {
    return false
  }

  return selectionsInStock
}

export default useInStock
